var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { Input } from "reactstrap";
var TextInput = /** @class */ (function (_super) {
    __extends(TextInput, _super);
    function TextInput(props) {
        return _super.call(this, props) || this;
    }
    TextInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, icon = _a.icon, onIconClick = _a.onIconClick, style = _a.style, error = _a.error, rightIcon = _a.rightIcon, onRightIconClick = _a.onRightIconClick, inputprops = __rest(_a, ["icon", "onIconClick", "style", "error", "rightIcon", "onRightIconClick"]);
        var inputPaddingLeft = icon ? { paddingLeft: '32px' } : {};
        var inputPaddingRight = rightIcon ? { paddingRight: '22px' } : {};
        return (React.createElement("div", { style: __assign(__assign({}, container), style), className: this.props.className || '' },
            icon && React.createElement("a", { href: "javascript:void(0)", onClick: function (e) {
                    e.preventDefault();
                    onIconClick && onIconClick(e, _this.input);
                } },
                React.createElement("img", { style: iconStyle, src: icon, width: 14 })),
            React.createElement(Input, __assign({ className: this.props.error ? 'error' : '', innerRef: function (ref) { return _this.input = ref; }, style: __assign(__assign(__assign({}, inputStyle), inputPaddingLeft), inputPaddingRight) }, inputprops, { addon: icon != undefined })),
            rightIcon && React.createElement("a", { href: "javascript:void(0)", onClick: function (e) {
                    e.preventDefault();
                    onRightIconClick && onRightIconClick(e, _this.input);
                }, style: rightLinkStyle },
                React.createElement("img", { src: rightIcon, width: 12 }))));
    };
    return TextInput;
}(React.PureComponent));
export default TextInput;
var container = {
    position: 'relative'
};
var iconStyle = {
    position: 'absolute',
    marginTop: '11px',
    marginLeft: '8px'
};
var rightLinkStyle = {
    position: 'absolute',
    display: 'block',
    top: '4.5px',
    right: '4px',
    width: '16px',
    height: '16px'
};
var inputStyle = {
    paddingTop: '0.5rem',
    lineHeight: '30px',
    fontSize: '.8rem'
};
//# sourceMappingURL=TextInput.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/components/TextInput.js
// module id = 290
// module chunks = 0